export const languageCodes = ['en', 'es', 'ja', 'hi'];

Object.freeze(languageCodes);
